import Swiper, { Pagination, Navigation } from "swiper";
import { $Qll } from "../utils/query-selector";

import 'swiper/css/bundle';

const initBestSellerSlider = () => {
  const slider = $Qll(".best-sellers");

  slider.forEach((seller) => {
    const sliderItems = $Qll('.best-sellers__slide', seller);
    const parentEl = seller.parentElement

    if (!seller) return;

    if (sliderItems.length <= 1) return;

    Swiper.use([Pagination, Navigation]);

    // eslint-disable-next-line no-new
    new Swiper(seller, {
      slidesPerView: 1,
      loop: false,
      observer: true,
      breakpoints: {
        280: {
          slidesPerView: 1.129,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
      navigation: {
        nextEl: `.best-sellers--next${seller.dataset.sectionId}`,
        prevEl: `.best-sellers--prev${seller.dataset.sectionId}`,
      },
      autoplay: false,
      on: {
        init: function () {
          parentEl.classList.add('swiper-slider-init')
        },
      }
    });
  });
  window.backInStockRegisterEvents()
}

export default initBestSellerSlider;
